<template>
  <div class="add-button" @click="goToCreateTimeRow">
    <img
      src="../assets/add.svg"
      alt="timesheet"
      height="25px"/>
  </div>
</template>

<script>
export default {
  props: {
    start: {
      type: Number,
      default: 0,
    },
    end: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      isSuperAdmin: false,
    };
  },
  created() {
    this.isSuperAdmin = this.$store.getters.isSuperAdmin;
  },
  methods: {
    goToCreateTimeRow() {
      if (this.isSuperAdmin) {
        this.$router.push({ name: 'create-time-row', params: { start: this.start, end: this.end } });
      }
    },
  },
};
</script>

<style scoped>
  .add-button {
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* To use while the action liked to this button not work */
  img {
    filter: grayscale(100%);
  }
</style>
